import { createContext, useContext, useEffect } from "react";

import "./toast-stack-badge.css";
import "./toast-stack.css";
import { AnimatedToastStack, useAnimatedToastStack } from "./animated-toast-stack";
import { subscribeToToastNotifications } from "./toast-notifications";

const ToastContext = createContext(null);

export function AppToastProvider({ children }) {
  const toastStack = useAnimatedToastStack({ defaultDuration: 3600, limit: 4 });

  useEffect(
    () => subscribeToToastNotifications(toastStack.showToast),
    [toastStack.showToast]
  );

  return (
    <ToastContext.Provider value={toastStack}>
      {children}
      <AnimatedToastStack
        classNames={{
          action: "toast-stack__action",
          close: "toast-stack__close",
          content: "toast-stack__content",
          copy: "toast-stack__copy",
          description: "toast-stack__description",
          iconWrap: "toast-stack__icon",
          item: "toast-stack__item",
          root: "toast-stack",
          surface: "toast-stack__surface",
          title: "toast-stack__title",
        }}
        maxVisible={4}
        onDismiss={toastStack.dismissToast}
        placement="fixed"
        position="top-right"
        toasts={toastStack.toasts}
      />
    </ToastContext.Provider>
  );
}

export function useAppToast() {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useAppToast must be used within AppToastProvider.");
  }

  return context;
}
